<template>
<div class="chapter">
<div class="inner_page">
<p class="tc"><span class="sz"><b>Table of Contents</b><br/><br/></span></p>
<p class="tcd"><span class="sz"><span href="#/section1" title="Link target outside of Sample">Cover</span><br/></span></p>
<p class="tcd"><span class="sz"><a href="#/section4">Dedication</a><br/></span></p>
<p class="tcd"><span class="sz"><a href="#/section5">Acknowledgments</a><br/></span></p>
<p class="tcd"><span class="sz"><a href="#/section6">Prologue</a><br/></span></p>
<p class="tcd"><span class="sz"><a href="#/section7">Chapter 1</a><br/></span></p>
<p class="tcd"><span class="sz"><span href="#/section8" title="Link target outside of Sample">Chapter 2</span><br/></span></p>
<p class="tcd"><span class="sz"><span href="#/section9" title="Link target outside of Sample">Chapter 3</span><br/></span></p>
<p class="tcd"><span class="sz"><span href="#/section10" title="Link target outside of Sample">Chapter 4</span><br/></span></p>
<p class="tcd"><span class="sz"><span href="#/section11" title="Link target outside of Sample">Chapter 5</span><br/></span></p>
<p class="tcd"><span class="sz"><span href="#/section12" title="Link target outside of Sample">Chapter 6</span><br/></span></p>
<p class="tcd"><span class="sz"><span href="#/section13" title="Link target outside of Sample">Epilogue</span><br/></span></p>
<p class="tcd"><span class="sz"><span href="#/section14" title="Link target outside of Sample">Meet the Author</span><br/></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?955b9228